import axios from "axios";
import { API_END_POINT } from "../../constants/api";

export const ADD_COMPANY_SUCCESS = "ADD_COMPANY_SUCCESS";
export const ADD_COMPANY_FAIL = "ADD_COMPANY_FAIL";

export const DELETE_COMPANY_SUCCESS = "DELETE_COMPANY_SUCCESS";
export const DELETE_COMPANY_FAIL = "DELETE_COMPANY_FAIL";

export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS";
export const UPDATE_COMPANY_FAIL = "UPDATE_COMPANY_FAIL";

export const GET_COMPANY_WITH_COMP_ID_SUCCESS =
  "GET_COMPANY_WITH_COMP_ID_SUCCESS";
export const GET_COMPANY_WITH_COMP_ID_FAIL = "GET_COMPANY_WITH_COMP_ID_FAIL";

export const CLEAR_STATE = "CLEAR_STATE";
export const GET_ALL_COMPANIES_SUCCESSFLL = "GET_ALL_COMPANIES_SUCCESSFLL";
export const GET_ALL_COMPANIES_FAIL = "GET_ALL_COMPANIES_FAIL";

// export const CREATE_COMPANY = "CREATE_COMPANY";
// export const GET_COMPANIES = "GET_COMPANIES";
// export const CREATE_COMPANY_SUCC = "CREATE_COMPANY_SUCC";
// export const CREATE_COMPANY_FAIL = "CREATE_COMPANY_FAIL";
// export const EDIT_COMPANY = "EDIT_COMPANY";
// export const DELETE_COMPANY = "DELETE_COMPANY";
// export const DELETE_COMPANY_SUCCESS = "DELETE_COMPANY_SUCCESS";
// export const DELETE_COMPANY_FAIL = "DELETE_COMPANY_FAIL";
// export const EDIT_COMPANY_SUCCESS = "EDIT_COMPANY_SUCCESS";
// export const EDIT_COMPANY_FAIL = "EDIT_COMPANY_FAIL";

let authToken = localStorage.getItem("usertoken");

const getErrorMessage = (err, fallback) =>
  err?.response?.data?.message || err?.message || fallback;

export function creatcompany(companyData) {
  return (dispatch) => {
    const token = localStorage.getItem("usertoken");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const body = JSON.stringify(companyData);
    axios
      .post(`${API_END_POINT}/company/add`, body, config)
      .then((res) =>
        dispatch({
          type: ADD_COMPANY_SUCCESS,
          payload: res.data,
        })
      )

      .catch((err) =>
        dispatch({
          type: ADD_COMPANY_FAIL,
          payload: getErrorMessage(
            err,
            "Failed to create company. Check backend is running on port 5000."
          ),
        })
      );
  };
}

export function getCompany(params) {
  let updatedAuthToken = localStorage.getItem("usertoken");
  console.log("params=>", params);
  let { userId, limit } = params;

  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${updatedAuthToken}`,
      },
    };
    axios
      .get(
        `${API_END_POINT}/company/get-company/user/${userId}${
          limit ? `/${limit}` : ""
        }`,
        config
      )
      .then((res) => {
        console.log("response get companies", res);

        dispatch({
          type: GET_ALL_COMPANIES_SUCCESSFLL,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_ALL_COMPANIES_FAIL,
          payload:
            err.response?.data?.message || "Failed to fetch companies",
        });
      });
  };
}

export function getSpecificCompany(params) {
  console.log("params=>", params);
  let { userId, companyId } = params;
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    axios
      .get(
        `${API_END_POINT}/company/get-company/user/${userId}/company/${companyId}`,
        config
      )
      .then((res) =>
        dispatch({
          type: GET_COMPANY_WITH_COMP_ID_SUCCESS,
          payload: res.data,
        })
      )
      .catch((err) => {
        dispatch({
          type: GET_COMPANY_WITH_COMP_ID_FAIL,
          payload: getErrorMessage(err, "Failed to fetch company"),
        });
      });
  };
}

export function deleteCompany(companyIdtoDelete) {
  console.log(companyIdtoDelete);
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    axios
      .delete(
        `${API_END_POINT}/company/delete-company/${companyIdtoDelete}`,
        config
      )
      .then((res) =>
        dispatch({
          type: DELETE_COMPANY_SUCCESS,
          payload: res.data,
        })
      )
      //
      .catch((err) =>
        dispatch({
          type: DELETE_COMPANY_FAIL,
          payload: getErrorMessage(err, "Failed to delete company"),
        })
      );
  };
}

export function editCompany(params, id) {
  return (dispatch) => {
    const token = localStorage.getItem("usertoken");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const body = JSON.stringify(params);

    axios
      .put(`${API_END_POINT}/company/edit-company/${id}`, body, config)
      .then((res) =>
        dispatch({
          type: UPDATE_COMPANY_SUCCESS,
          payload: res.data,
        })
      )

      .catch((err) =>
        dispatch({
          type: UPDATE_COMPANY_FAIL,
          payload: getErrorMessage(err, "Failed to update company"),
        })
      );
  };
}

export function clearState() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_STATE,
    });
  };
}
